import useShowPropertyType from "@hooks/useShowPropertyType";
import ChildCard from "@shared-layouts/ChildCard";
import {
  TypographyH5,
  TypographyH6,
} from "@shared-ui-components/CustomTypography";
import ProgressBar from "@shared-ui-components/ProgressBar";

import Colors from "@constants/Colors";
import { Flex } from "@src/components/shared-ui-components/Flex";
import { ErrorState, formatNumberWithCommaAndDollar } from "@src/constants";
import { Skeleton } from "@mui/material";
import {
  ChildCardColumnWrapper,
  ChildCardContentWrapper,
  CurrentProgressColorTag,
  CurrentProgressWrapper,
  EventTextWrapper,
  PercentageEventNameWrapper,
  PercentageWrapper,
  TitleValueWrapper,
} from "./style";

const CurrentProgress = (props: {
  filter: number;
  current: number | null;
  target: number | null;
  percentage: number | null;
  eventName: string;
  loading: boolean;
}) => {
  const { filter, current, target, percentage, eventName, loading } = props;

  const isRestaurantAndCateringRevenueCenters = useShowPropertyType(
    filter,
    "propertyRestaurantCateringRevenueCenters"
  );

  const quickServiceRevenueCenters = useShowPropertyType(
    filter,
    "quickServiceRevenueCenters"
  );

  const getPercentage = () => {
    if (loading) return <Skeleton width="25%" />;
    if (percentage === undefined || percentage === null)
      return <PercentageWrapper errorState>N/A</PercentageWrapper>;
    return <PercentageWrapper>{`${percentage}%`}</PercentageWrapper>;
  };

  const getCurrentSales = () => {
    if (loading) return <Skeleton width="70%" />;
    if (current === undefined || current === null) return <ErrorState />;
    return (
      <ChildCardColumnWrapper>
        <ChildCardContentWrapper>
          <TypographyH5>{formatNumberWithCommaAndDollar(current)}</TypographyH5>
        </ChildCardContentWrapper>
      </ChildCardColumnWrapper>
    );
  };

  const getTargetSales = () => {
    if (loading) return <Skeleton width="70%" />;
    if (target === undefined || target === null) return <ErrorState />;
    return (
      <ChildCardColumnWrapper>
        <ChildCardContentWrapper>
          <TypographyH5>{formatNumberWithCommaAndDollar(target)}</TypographyH5>
        </ChildCardContentWrapper>
      </ChildCardColumnWrapper>
    );
  };

  return (
    <ChildCard title="Current Progress">
      <CurrentProgressWrapper>
        <PercentageEventNameWrapper>
          <EventTextWrapper>
            {eventName && (
              <span>
                <b>Event:&nbsp;</b>
                {eventName}
              </span>
            )}
          </EventTextWrapper>
          {!(
            isRestaurantAndCateringRevenueCenters || quickServiceRevenueCenters
          ) && getPercentage()}
        </PercentageEventNameWrapper>
        {!(
          isRestaurantAndCateringRevenueCenters || quickServiceRevenueCenters
        ) && (
          <ProgressBar
            progress={percentage || 0}
            isEmptyState={percentage === undefined || percentage === null}
          />
        )}
        <Flex flexWrap="wrap" justifyContent="space-between">
          <TitleValueWrapper>
            {!(
              isRestaurantAndCateringRevenueCenters ||
              quickServiceRevenueCenters
            ) && (
              <CurrentProgressColorTag
                backgroundColor={Colors.secondarypurple_35}
              />
            )}
            <CurrentProgressWrapper>
              <TypographyH6>Current Sales</TypographyH6>
              {getCurrentSales()}
            </CurrentProgressWrapper>
          </TitleValueWrapper>
          {!(
            isRestaurantAndCateringRevenueCenters || quickServiceRevenueCenters
          ) && (
            <TitleValueWrapper>
              <CurrentProgressColorTag backgroundColor={Colors.neutralwhite} />
              <CurrentProgressWrapper>
                <TypographyH6>Target Sales</TypographyH6>
                {getTargetSales()}
              </CurrentProgressWrapper>
            </TitleValueWrapper>
          )}
        </Flex>
      </CurrentProgressWrapper>
    </ChildCard>
  );
};

export default CurrentProgress;
